
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import PageFooter from '@/components/page-footer.vue';
	import {
		getAgentCheckOrderRecordDetail
	} from '@/api/order'

	@Component({
		name: 'agency-check-record-detail',
		components: {
			PageFooter
		}
	})
	export default class AgencyCheckRecordDetail extends Vue {
		private id = +this.$route.query.id;
		private userId = +this.$route.query.userId;
		private IDKey = '';
		private IDStrKey = '';
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private list = [];
		private orderState: any = {
			pedding: 0,
			pass: 1,
			refuse: 2,
			allPass: 3
		};
		private tableloading = false

		mounted() {
			this.getList();
		}

		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.IDKey = '';
			this.IDStrKey = '';
			this.pageNo = 1;
			this.getList();
		}

		private async getList() {
			let params: any = {
				check_user_id: this.userId,
				product_id: this.id,
				page_no: this.pageNo,
				page_size: this.pageSize
			}
			if (this.IDKey) {
				params.order_id = +this.IDKey
			}
			if (this.IDStrKey) {
				params.order_str_id = this.IDStrKey
			}
			try {
				this.tableloading = true
				const res: any = await getAgentCheckOrderRecordDetail(params);
				this.list = res.info || []
				this.total = res.count;
			} catch (e) {
				console.log(e)
			} finally{
				this.tableloading = false
			}
		}

		/**
		 * @func 跳转到订单详情
		 */
		private toDetail(id: number) {
			this.$router.push({
				name: 'Order_Detail',
				query: {
					id: id + ''
				}
			})
		}
	}
